import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var AlignCenter = createReactComponent("AlignCenter", ["svg", defaultAttributes, [["line", {
  x1: "21",
  y1: "6",
  x2: "3",
  y2: "6",
  key: "1kn1du"
}], ["line", {
  x1: "17",
  y1: "12",
  x2: "7",
  y2: "12",
  key: "go884h"
}], ["line", {
  x1: "19",
  y1: "18",
  x2: "5",
  y2: "18",
  key: "19guv1"
}]]]);
export default AlignCenter;